import { APICore } from './apiCore'

const api = new APICore()

function getOptionAnswerOpinometros (params) {
  const baseUrl = '/option-answer-opinometro'
  return api.get(baseUrl, params)
}

function getOptionAnswerOpinometro (id) {
  const baseUrl = `/option-answer-opinometro/${id}`
  return api.get(baseUrl, {})
}

function addOptionAnswerOpinometro (params) {
  const baseUrl = '/option-answer-opinometro'
  return api.create(baseUrl, params)
}

function updateOptionAnswerOpinometro (params) {
  const baseUrl = '/option-answer-opinometro'
  return api.update(baseUrl, params)
}

function deleteOptionAnswerOpinometro (params) {
  const baseUrl = '/option-answer-opinometro'
  return api.delete(baseUrl, params)
}

export { getOptionAnswerOpinometros, getOptionAnswerOpinometro, addOptionAnswerOpinometro, updateOptionAnswerOpinometro, deleteOptionAnswerOpinometro }
